const mixins = {
  data: () => ({
    selectedCountry: null
  }),
  computed: {
    countryList() {
      return this.clientModel.countryList
    },
    defaultCountry() {
      if (this.countryList.length === 1) {
        return this.countryList[0]
      } else {
        return this.countryList.find(a => { return a.isDefault })
      }
    },
    hasDefaultCountry() {
      return this.defaultCountry !== undefined
    },
    hasMultipleMarkets() {
      return this.countryList.length > 1
    },
    createInitialText() {
      return !this.hasDefaultCountry ? this.tStatic('addressCountryPlaceholder') : null
    },
    useCountryDropDown() {
      return this.countryList.length > 2
    },
    selectedActiveCountry: {
      get: function () {
        return this.selectedCountry
      },
      set: function (newValue) {
        this.selectedCountry = newValue
      }
    }
  },
  methods: {
    setActiveCountry(countryCode) {
      this.selectedActiveCountry = this.clientModel.countryList.find(c => c.value === countryCode)
    }
  }
}

export default mixins
